import i18n from 'reactifi-local/i18n/translate';
import moment from 'moment';
i18n.loadTranslations();
moment.locale(i18n.language);
export default i18n;
